import * as React from "react";
import { useEffect } from "react";
import DeviceContext from "../../utils/indentifyDevice";
import HeaderDesk from "./HeaderDesk/HeaderDesk";
import "../../stylesheets/components/header/nav/HeaderRefactor.scss";
const Header = () => {
    useEffect(() => {
        if (DeviceContext().isDesktop) {
            require("../../stylesheets/components/header/nav/navDesk.scss");
        }
        else {
            require("../../stylesheets/components/header/nav/navMob.scss");
        }
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(HeaderDesk, null)));
};
export default Header;
